import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_CARD, M_IMAGE_FRAME } from './mobileMotion'

export default function Slide7M() {
  const { t } = useLanguage()
  const s = t.slides.slide7
  const src = s.image || '/slides/slide_07.png'

  return (
    <MobileSlideShell>
      <motion.p
        {...fadeScaleProps(0)}
        className="text-[13px] font-bold uppercase tracking-[0.2em] text-[#1B2A6B]/50"
      >
        {s.eyebrow}
      </motion.p>

      <motion.h2
        {...fadeScaleProps(0.06)}
        className="text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.title}
      </motion.h2>

      <motion.div {...fadeScaleProps(0.1)} className={M_IMAGE_FRAME}>
        <img src={src} alt="" className="block w-full" loading="lazy" decoding="async" />
      </motion.div>

      <motion.div {...fadeScaleProps(0.14)} className={M_CARD}>
        <h3 className="mb-3 text-[17px] font-semibold text-[#1B2A6B]">
          {s.engineTypesTitle}
        </h3>
        <ul className="flex flex-col gap-3">
          {s.engines?.map((line) => (
            <li
              key={line}
              className="flex gap-3 text-[16px] leading-relaxed text-[#1B2A6B]/70"
            >
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#22A756]" />
              <span className="whitespace-pre-line">{line}</span>
            </li>
          ))}
        </ul>
      </motion.div>

      <motion.div {...fadeScaleProps(0.2)} className={M_CARD}>
        <h3 className="mb-3 text-[17px] font-semibold text-[#1B2A6B]">
          {s.vehicleTypesTitle}
        </h3>
        <ul className="flex flex-col gap-3">
          {s.vehicles?.map((line) => (
            <li
              key={line}
              className="flex gap-3 text-[16px] leading-relaxed text-[#1B2A6B]/70"
            >
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#1B2A6B]/35" />
              <span className="whitespace-pre-line">{line}</span>
            </li>
          ))}
        </ul>
      </motion.div>

      <motion.p
        {...fadeScaleProps(0.26)}
        className="text-[16px] leading-relaxed text-[#1B2A6B]/65"
      >
        {s.footer}
      </motion.p>
    </MobileSlideShell>
  )
}
